import React, { CSSProperties, ReactNode } from "react";
import styled from "styled-components";

interface EqualColumnsGridProps {
  numColumns: number;
  rowGap?: number;
  columnGap?: number;
  style?: CSSProperties;
  children?: ReactNode;
}

const EqualColumnsGrid = React.forwardRef<
  HTMLDivElement,
  EqualColumnsGridProps
>(({ numColumns, rowGap = 16, columnGap = 16, style, children }, ref) => {
  return (
    <Wrapper
      $numColumns={numColumns}
      $rowGap={rowGap}
      $columnGap={columnGap}
      style={style}
      ref={ref}
    >
      {children}
    </Wrapper>
  );
});

export default EqualColumnsGrid;

const Wrapper = styled.div<{
  $numColumns: number;
  $rowGap: number;
  $columnGap: number;
}>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.$numColumns}, minmax(0, 1fr));
  grid-gap: ${(p) => p.$rowGap}px ${(p) => p.$columnGap}px;
`;
